import { action, makeObservable, observable } from "mobx";

import { NavigateFunction } from "react-router-dom";
import { UrlOperators } from "../../../../../../apps/grids/builder/directorBuilder/grids/base/addons/FilterAddon/FilterAddonContants";
import {
  CommonColDefFieldNamesEnum,
  ImpactColDefFieldNamesEnum
} from "../../../../../../apps/grids/builder/enums/AgGridColDefFieldNameEnum";
import { GridPages } from "../../../../../../apps/grids/routes/pages";
import { BaseModel } from "../../../../../../core/util/BaseModel";
import { Enums } from "../../../../../../enums";
import UsersApi, { UsersApi as IUsersApi } from "../../../../../../services/api/v2/users/Users.api";
import { PieDataObject } from "../../../../organisations/organisationDashboard/models/dashboard_interfaces";

export class ImpactsPerProjectByLevelSidebarModel extends BaseModel {
  userProvider: IUsersApi;
  @observable isLoading = true;
  @observable.ref drillDownPieData: PieDataObject[];
  organisationId: number;
  userId: number;
  impactLevel: number;
  pieColors: string[];
  navigate: NavigateFunction;
  authUser: FP.Entities.IUser;

  constructor(
    authUser: FP.Entities.IUser,
    organisationId: number,
    userId: number,
    impactLevel: number,
    navigate: NavigateFunction
  ) {
    super();
    makeObservable(this);
    this.userProvider = UsersApi;
    this.organisationId = organisationId;
    this.userId = userId;
    this.authUser = authUser;
    this.impactLevel = impactLevel;
    this.navigate = navigate;
    this.pieColors = [
      "#fdd886",
      "#ffc036",
      "#feae95",
      "#f49d4e",
      "#dc9700",
      "#f7820d",
      "#cc660a",
      "#966700",
      "#ed7650",
      "#ac5337",
      "#8a4100",
      "#452015"
    ];
  }

  onMount = async () => {
    await this.loadPieData();
  };

  loadPieData = async () => {
    const userProjects = await this.userProvider.getProjectsWithImpactsByLevelAndUserId(
      this.organisationId,
      this.userId,
      this.impactLevel
    );

    const res = userProjects.payload.map(usrProj => {
      return {
        id: usrProj.id,
        label: usrProj.label,
        value: usrProj.value,
        color: ""
      };
    });

    this.setModalPieData(res);
    return true;
  };

  getPieColors = () => {
    const result = [...this.pieColors];
    const zeroIndexHasValue = this.drillDownPieData[0].value > 0;
    const zeroIndexIsNoAccessProject = this.drillDownPieData[0].label === "Projects with no access";
    if (zeroIndexHasValue && zeroIndexIsNoAccessProject) result.unshift("#E5E5E5");
    return result;
  };

  @action
  setModalPieData = (data: PieDataObject[]) => {
    this.drillDownPieData = data;
    this.isLoading = false;
  };

  onPieClick = onClickData => {
    const link = `${GridPages.impacts.generateLink(this.organisationId, onClickData.id)}?${
      ImpactColDefFieldNamesEnum.ImpactLevel
    }=${UrlOperators.contains.symbol}${Enums.Translator.ImpactLevel(this.impactLevel)}&${
      CommonColDefFieldNamesEnum.Owner
    }=${UrlOperators.contains.symbol}${this.authUser.firstName}%20${this.authUser.lastName}`;
    window.open(appConfig.baseUrl + link, "_blank");
  };
}
